export default __webpack_public_path__ + "static/media/patternfolding-icon-grayscale.e507c0e2.svg";